import { defineStore } from "pinia";
import { ref } from "vue";

export const useGlobalLoadingScreen = defineStore("globalLoadingScreen", () => {
    const isLoading = ref<boolean>(true);
    const artificialTimeOutActivate = ref<ReturnType<typeof setTimeout>>();
    const artificialTimeOutDeactivate = ref<ReturnType<typeof setTimeout>>();
    const timeOutTime = ref<number>(1000);

    const activateLoadingScreen = (callback?: () => void) => {
        isLoading.value = true;
        artificialTimeOutActivate.value = setTimeout(() => {
            if (callback) callback();
            clearTimeout(artificialTimeOutActivate.value);
        }, timeOutTime.value);
    };

    const deactivateLoadingScreen = (callback?: () => void) => {
        artificialTimeOutDeactivate.value = setTimeout(() => {
            isLoading.value = false;
            if (callback) callback();
            clearTimeout(artificialTimeOutDeactivate.value);
        }, timeOutTime.value);

    };

    return {
        isLoading,
        activateLoadingScreen,
        deactivateLoadingScreen
    };
});
